import { ROLES } from "@/shared/constants/roles";

export const checklistAdminRoutes = [
  {
    path: "checklist",
    name: "checklist-admin",
    component: () => import("./views/ChecklistAdminView.vue"),
    meta: {
      requiredRole: ROLES.INSTITUTION_ADMIN,
    },
  },
  {
    path: "checklist/:id/edit",
    name: "checklist-editor",
    component: () => import("./views/ChecklistEditorView.vue"),
    meta: {
      requiredRole: ROLES.INSTITUTION_ADMIN,
    },
  },
  {
    path: "checklist/:id/view",
    name: "checklist-viewer",
    component: () => import("./views/ChecklistViewerView.vue"),
    meta: {
      requiredRole: ROLES.INSTITUTION_ADMIN,
    },
  },
];

export const checklistLearnerRoutes = [
  {
    path: "checklist",
    name: "checklist-learner",
    component: () => import("./views/ChecklistLearnerView.vue"),
    meta: {
      exactRole: ROLES.STUDENT,
    },
  },
];
